import type { TargetDataPointValueJson } from '@/api/targetDataPoints';

/*
 * Shared local-state shape used by every per-data-type entry widget.
 *
 * `valueNumeric` is the canonical scalar the server will receive and
 * analytics will graph. `valueJson` mirrors server storage: populated for
 * trial / percent / task_analysis, null for frequency / duration. `notes`
 * is an optional clinician annotation. `dirty` flips true on any user
 * interaction — the pane's Save button skips untouched entries so an
 * unchanged re-save doesn't trip the server UNIQUE constraint or create
 * a spurious amendment audit row.
 *
 * Each widget owns how the user inputs values and derives `valueNumeric`
 * + `valueJson` from that input. The dispatcher (TargetDataEntry) and
 * the pane (DataCollectionPane) deal only in this shape.
 */
export interface EntryState {
    valueNumeric: number | null;
    valueJson: TargetDataPointValueJson | null;
    notes: string;
    dirty: boolean;
}

export interface EntryWidgetProps {
    value: EntryState;
    onChange: (next: EntryState) => void;
    disabled?: boolean;
}

export function blankEntry(): EntryState {
    return { valueNumeric: null, valueJson: null, notes: '', dirty: false };
}
